module.exports = __webpack_public_path__ + "img/bg-dot.beebd02.png";